import { render, staticRenderFns } from "./DataProtectionView.vue?vue&type=template&id=c4e16b7c&"
import script from "./DataProtectionView.vue?vue&type=script&lang=js&"
export * from "./DataProtectionView.vue?vue&type=script&lang=js&"
import style0 from "./DataProtectionView.vue?vue&type=style&index=0&id=c4e16b7c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports